export default __webpack_public_path__ + "static/media/pnsv_stand_Holcim.4e66a69f.png";